(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/date-selector/components/name-day-by-date.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/date-selector/components/name-day-by-date.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const IconButton = svs.ui.ReactIconButton;
const Icon = svs.ui.ReactIcon;
const _ReactWindow = ReactWindow,
  FixedSizeList = _ReactWindow.FixedSizeList,
  areEqual = _ReactWindow.areEqual;
const DATE_AND_TIME = svs.tickets_giftshop.constants.names.DATE_AND_TIME;
const _React = React,
  useState = _React.useState,
  useRef = _React.useRef,
  useEffect = _React.useEffect,
  useCallback = _React.useCallback,
  useMemo = _React.useMemo,
  memo = _React.memo;
const _svs$tickets_giftshop = svs.tickets_giftshop.gift.giftform.date_selector.components.util,
  mapMonthByNumber = _svs$tickets_giftshop.mapMonthByNumber,
  getMonth = _svs$tickets_giftshop.getMonth,
  getYear = _svs$tickets_giftshop.getYear,
  isLeapYear = _svs$tickets_giftshop.isLeapYear;
const NAME_DAY_BY_DATE = svs.tickets_giftshop.constants.dateSelectorKey.NAME_DAY_BY_DATE;
const DayAndNames = _ref => {
  let day = _ref.day,
    names = _ref.names;
  return React.createElement(React.Fragment, null, React.createElement("b", null, "".concat(day, ". ")), React.createElement("span", null, names));
};
const Row = memo(_ref2 => {
  var _items$day;
  let index = _ref2.index,
    data = _ref2.data,
    style = _ref2.style;
  const classNames = ['tg-name-day-by-date-row-item'];
  const items = data.items,
    selectDate = data.selectDate,
    isActive = data.isActive,
    isDisabled = data.isDisabled,
    month = data.month;
  const day = Object.keys(items)[index];
  const names = (_items$day = items[day]) === null || _items$day === void 0 ? void 0 : _items$day.join(', ');
  const active = isActive(day);
  const disabled = isDisabled(day);
  if (active) {
    classNames.push('tg-name-day-by-date-selected fc-white');
  } else {
    classNames.push('fc-black');
  }
  if (disabled) {
    classNames.push('tg-name-day-by-date-disabled');
  }
  return React.createElement("div", {
    className: "tg-name-day-by-date-row",
    style: style
  }, React.createElement("a", {
    className: classNames.join(' '),
    href: "",
    onClick: e => {
      e.preventDefault();
      !disabled && selectDate(day, month);
    }
  }, React.createElement(DayAndNames, {
    day: day,
    names: names
  })));
}, areEqual);
const NameDayByDate = _ref3 => {
  let date = _ref3.date,
    dateData = _ref3.dateData,
    onInputChange = _ref3.onInputChange,
    _ref3$minDate = _ref3.minDate,
    minDate = _ref3$minDate === void 0 ? svs.utils.date.SimpleDate(new Date()) : _ref3$minDate,
    _ref3$maxDate = _ref3.maxDate,
    maxDate = _ref3$maxDate === void 0 ? svs.utils.date.SimpleDate(new Date(new Date().setFullYear(new Date().getFullYear() + 1))) : _ref3$maxDate;
  const listRef = useRef(null);
  const _useState = useState(getMonth(date)),
    _useState2 = _slicedToArray(_useState, 2),
    month = _useState2[0],
    setMonth = _useState2[1];
  const _useState3 = useState(getYear(date)),
    _useState4 = _slicedToArray(_useState3, 2),
    year = _useState4[0],
    setYear = _useState4[1];
  const formatDate = useCallback((day, month) => "".concat(year, "-").concat(month < 10 ? '0' : '').concat(month, "-").concat(day < 10 ? '0' : '').concat(day), [year]);
  const disableIncrement = formatDate(31, month) > maxDate;
  const disableDecrement = formatDate(1, month) < minDate;
  const selectDate = useCallback(function (day) {
    let m = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : month;
    const date = formatDate(day, m);
    onInputChange({
      target: {
        value: {
          date,
          time: '08:00',
          dateSelectorUsed: NAME_DAY_BY_DATE
        },
        name: DATE_AND_TIME
      }
    });
  }, [formatDate, onInputChange, month]);
  useEffect(() => {
    if (listRef.current) {
      const dayIndex = parseInt(date.split('-')[2], 10);
      listRef.current.scrollToItem(dayIndex - 1, 'center');
    }
  }, [month]);
  const updateMonth = useCallback((e, month, incrementOrDecrement) => {
    e === null || e === void 0 || e.preventDefault();
    let newMonth = month + incrementOrDecrement;
    if (newMonth > 12) {
      newMonth = 1;
      setYear(year + 1);
    }
    if (newMonth < 1) {
      newMonth = 12;
      setYear(year - 1);
    }
    if (!dateData[newMonth]) {
      updateMonth(e, newMonth, incrementOrDecrement);
    } else {
      setMonth(newMonth);
    }
  }, [dateData, year]);
  const data = useMemo(() => {
    if (!isLeapYear(year)) {
      const newFebruary = _objectSpread({}, dateData[2]);
      delete newFebruary[29];
      dateData = _objectSpread(_objectSpread({}, dateData), {}, {
        2: newFebruary
      });
    }
    return {
      itemsCount: Object.keys(dateData[month] || []).length,
      items: dateData[month] || [],
      selectDate,
      isActive: day => formatDate(day, month) === date,
      isDisabled: day => formatDate(day, month) > maxDate || formatDate(day, month) < minDate
    };
  }, [year, dateData, month, selectDate, formatDate, date, maxDate, minDate]);
  return React.createElement("div", {
    className: "tg-date-input gutter-sm-2"
  }, React.createElement("div", {
    className: "tg-name-day-by-date-pagination padding-2"
  }, React.createElement(IconButton, {
    disabled: disableDecrement,
    onClick: e => updateMonth(e, month, -1)
  }, React.createElement(Icon, {
    className: "bold",
    icon: "menu-left"
  })), React.createElement("span", {
    className: "tg-name-day-by-date-pagination-header"
  }, mapMonthByNumber(month), " ", year), React.createElement(IconButton, {
    disabled: disableIncrement,
    onClick: e => updateMonth(e, month, 1)
  }, React.createElement(Icon, {
    className: "bold",
    icon: "menu-right"
  }))), React.createElement(FixedSizeList, {
    className: "List tg-date-selector-inverted-box-shadow",
    height: 360,
    itemCount: data.itemsCount,
    itemData: data,
    itemSize: 36,
    layout: "vertical",
    ref: listRef
  }, Row));
};
svs.tickets_giftshop.gift.giftform.date_selector.components.NameDayByDate = NameDayByDate;

 })(window);